import { Component } from 'react';
import Constants from '../../../constants/constants';
import AuthService from '../../../services/auth/authService';

const gameIconStyle = {
  width: '125px',
};

const gameIconContainer = {
  display: 'inline-block',
};

class GameIcon extends Component {
  render() {
    const { game, player_id, isLink } = this.props;
    const _style = this.props.gameIconStyle || gameIconStyle;
    const token = AuthService.getAuthToken(); //DONE: get token from local storage
    const linkProps = {};
    if (isLink) {
      const port = window.location.port;

      let platformURL = 'https://' + window.location.hostname;

      if (port !== '') {
        platformURL += ':' + port;
      }

      platformURL = encodeURIComponent(platformURL);
      const url = `${Constants.PLAY_CONTENT_URL}/play_game?game_id=${game.id}&player_id=${player_id}&auth=${token}&purl=${platformURL}`;
      linkProps.href = url;
    }

    const gameIcon = this.gameIcon(_style);
    return isLink ? <a {...linkProps}>{gameIcon}</a> : gameIcon;
  }

  gameIcon(_style) {
    const { game, iconClassName, showName } = this.props;

    const onClick = this.props.onClick;

    if (!game || !Object.keys(game) || Object.keys(game).length === 0) {
      return <div className="icon_not_available">N/A</div>;
    }

    const iconImage = new URL(`../../../static/assets/game_icons/${game.image_path}`, import.meta.url).href;

    return (
      <div className="game_icon_container" style={gameIconContainer} id={game.id}>
        <img style={_style} src={iconImage} alt={game.image_filename} onClick={onClick} className={iconClassName} />
        {showName && <p className="mx-0 mt-1 mb-0 p-0 small text-secondary text-center">{game.name}</p>}
      </div>
    );
  }
}

export default GameIcon;
